module.exports = __webpack_public_path__ + "static/097_muszka_anagl-215612b18eab78a40504ff3d1bafb6f0.jpg";